enum HarmonizationSettingSubmissionHamSubType {
  CROP = "crop",
  ANIMAL = "animal"
}

export default HarmonizationSettingSubmissionHamSubType
